import React, {useEffect, useContext, useState} from 'react';
import {Amplify} from 'aws-amplify';
import {UserContext} from '../../../context/UserContext';
import CryptoJS from 'crypto-js';
import AppIndex from '../../app-index/AppIndex';
import AuthIndex from '../../auth/auth-index/AuthIndex';
import PageLoader from '../../util/page-loader/PageLoader';
import {AccountProvider} from '../../../context/AccountContext';
import {CampaignProvider} from '../../../context/CampaignContext';

const AuthLogic = () => {
    const [authAlertMessage, setAuthAlertMessage] = useState('');
    const {userInfo} = useContext(UserContext);
    const [pageLoaded, setPageLoaded] = useState(userInfo?.authView)

    useEffect(() => {
        setPageLoaded(userInfo?.authView);
    }, [userInfo?.authView]);

    if (pageLoaded) {
        return userInfo?.authView !== 'authenticated' ? (
            <AuthIndex/>
        ) : (
            <AccountProvider>
                <CampaignProvider>
                    <AppIndex/>
                </CampaignProvider>
            </AccountProvider>
        );
    } else {
        return <div className="loader">loading</div>
    }
};

export default AuthLogic;
